import { BRAND, CONTACT } from "@/data/content";

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-legales-page" className="bg-white">
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-8">Mentions légales</h1>
          <div className="space-y-8 text-slate-600 leading-relaxed">
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Éditeur du site</h2>
              <p>
                Ce site est édité par <strong>{BRAND.name}</strong>, micro-activité spécialisée
                dans l'accompagnement à la visibilité locale des commerces et artisans de proximité.
              </p>
              <p className="mt-2">Zone d'intervention : {CONTACT.zoneText}.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Contact</h2>
              <p>Téléphone : {CONTACT.phone}</p>
              <p>Email : {CONTACT.email}</p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Hébergement</h2>
              <p>
                Le site est hébergé par un prestataire d'hébergement web professionnel. Les coordonnées
                complètes de l'hébergeur peuvent être obtenues sur simple demande à l'adresse email ci-dessus.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus présents sur ce site (textes, logo, visuels, structure) est protégé
                par le droit de la propriété intellectuelle. Toute reproduction sans autorisation est interdite.
              </p>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-2">Responsabilité</h2>
              <p>
                {BRAND.name} s'efforce d'assurer l'exactitude des informations diffusées sur ce site, mais ne
                peut être tenue responsable des erreurs, omissions ou indisponibilités temporaires.
              </p>
            </div>
            <p className="text-sm text-slate-400">Dernière mise à jour : {new Date().getFullYear()}.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
